import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores/Store';
import PreviewBrief from '../BriefPreview';
import BackIcon from '../../../assets/images/BackArrow.svg';
import EditIcon from '../../../assets/images/EditIcon.svg';
import './style.scss';
import { TextInput, TextInputDropdown } from '../../../components';
import { MenuItem } from "@mui/material";
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`

var mobile = require('is-mobile');
//{ backClick, selectedPro, leads, pros }
const ViewClient = observer(({ backClick, selectedPro, leads, pros }) => {
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [IsEdit, setIsEdit] = useState(false);
    const [activeTab, setActiveTab] = useState('profile');
    const [User, setUser] = useState(selectedPro);
    const [ViewProject, setViewProject] = useState(false);
    const [TypeSelected, setTypeSelected] = useState('Brief');
    const [Briefs, setBriefs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [SelectedProject, setSelectedProject] = useState({});
    const [AllProjects, setAllProjects] = useState([]);
    const [FullName, setFullName] = useState('');
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [Projects, setProjects] = useState([]);
    const [IsEdited, setIsEdited] = useState()

    useEffect(() => {
        getUsers();
    }, [selectedPro]);

    const getUsers = async () => {
        let fullName = '';
        try {
            store.setLoading(true);
            let allProjects = [];
            if (selectedPro.projects) {
                allProjects = selectedPro.projects;
                allProjects = allProjects.concat(selectedPro.briefs);
            }
            if (selectedPro.firstName && selectedPro.lastName) {
                fullName = `${selectedPro.firstName} ${selectedPro.lastName}`;
            }
            setFullName(fullName);
            setAllProjects(allProjects);
            setLeads(leads);
            setProfessionals(pros);
            setBriefs(selectedPro.briefs);
            setProjects(selectedPro.projects);
            setUser(selectedPro);
        } catch (e) {
            console.log(e);
        } finally {
            store.setLoading(false);
        }
    };
    const truncateString = (str, num) => {
        if (str.length <= num) {
            return str;
        }
        return str.slice(0, num) + '...';
    };
    const handleTabClick = (tab) => {
        setIsEdit(false);
        setActiveTab(tab);
        forceUpdate();
    };
    const handleEditUser = () => {
        setIsEdit(true);
        forceUpdate();
    };
    const handleNavigateToMainScreen = () => {
        backClick(false, IsEdited);
        forceUpdate();
    };
    const handleTabChange = (e) => {
        setTypeSelected(e.currentTarget.id);
        forceUpdate();
    };
    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    };
    function filteredBriefs(data, term, isProject) {
        let returnDtata = [];
        data.filter(brief => {
            const searchValue = term.toLowerCase();
            if (isProject) {
                if (brief.title.toLowerCase().includes(searchValue)) {
                    returnDtata.push(brief);
                };
            } else {
                if (brief.briefTitle.toLowerCase().includes(searchValue)) {
                    returnDtata.push(brief);
                };
            };
        });
        return returnDtata;
    };
    const handleSearchChange = (e) => {
        let briefs = selectedPro.briefs;
        let isProject = false;
        if (TypeSelected === 'Project') {
            briefs = selectedPro.projects;
            isProject = true;
        };
        setSearchTerm(e.target.value);
        if (e.target.value === '') {
            setBriefs(selectedPro.briefs);
            setProjects(selectedPro.projects);
        }

        if (isProject) {
            setProjects(filteredBriefs(briefs, e.target.value, isProject));
        } else {
            setBriefs(filteredBriefs(briefs, e.target.value, isProject));
        }
    };
    const handleUserInfoChange = (e) => {
        let user = User;
        if (!Object.keys(user).includes('professional')) {
            user['professional'] = {
                gender: '',
                languages: ''
            }
        };
        if (e.currentTarget.id === 'FullName') {
            let fullName = e.target.value;
            user.firstName = fullName.split(' ')[0] ?? '';
            user.lastName = fullName.split(' ')[1] ?? '';
            setFullName(fullName);
            user['fullName'] = `${user.firstName} ${user.lastName}`
        }
        if (e.currentTarget.id === 'Phone') {
            user.phone = e.target.value;
        }
        if (e.currentTarget.id === 'Email') {
            user.email = e.target.value;
        }
        if (e.currentTarget.id === 'AccountType') {
            user.accountType = e.target.value;
        }
        if (e.currentTarget.id === 'paymentMethod') {
            user.paymentMethod = e.target.value;
        }
        if (e.currentTarget.id === 'compName') {
            User.companyName = e.target.value;
        }
        if (e.currentTarget.id === 'industry') {
            user.companyIndustry = e.target.value
        }
        if (e.currentTarget.id === 'vatnumber') {
            user.companyVatNumber = e.target.value;
        }
        if (e.currentTarget.id === 'billing') {
            user.companyAddress = e.target.value;
        }

        setUser(user);
        forceUpdate();
    };
    const updateUserClicked = async () => {
        try {
            store.setLoading(true);

            let user = User;
            let id = user._id;
            let isedited = false;
            delete user.briefs
            delete user.projects

            let update = await store.updateUserById(id, user);

            if (update !== 'error') {
                isedited = true;
                backClick(false, true);
                setIsEdited(isedited)
            } else {
                return
            }
        } catch (e) {
            console.log(e);
        } finally {
            // store.setLoading(false)
        }
    }
    const cancelUpdateUser = () => {
        setIsEdit(false);
        forceUpdate();
    };
    const getSelectedProject = (id) => {
        let projects = [...AllProjects];
        let selectedProject = projects.find(project => project._id === id);
        setSelectedProject(selectedProject);
        setViewProject(true);
        forceUpdate();
    };
    const backClicked = (e, isUpdate) => {

        if (isUpdate) {
            // getUsers();
            setIsEdited(true);
            backClick(false, true);
        } else {
            setViewProject(e);
            forceUpdate();
        }
    }
    function handleUserGenderChange(e) {

        let user = { ...User };
        if (Object.keys(user).includes('professional')) {
            if (user.professional !== null) {
                if (user.professional.gender) {
                    user.professional.gender = e.target.value;
                } else {
                    user.professional['gender'] = e.target.value;
                }
            } else {
                user['professional'] = {
                    gender: e.target.value,
                }
            }
        } else {
            user['professional'] = {
                gender: e.target.value,
            }
        }
        setUser(user)
        forceUpdate()
    }
    function handleUserExpChange(e) {
        let user = { ...User };
        user.experienceLevel = e.target.value;

        if (user['experienceLevel']) {
            user.experienceLevel = e.target.value;
        } else {
            user['experienceLevel'] = e.target.value
        }
        setUser(user)
    }
    function handleUserTheRoleChange(e) {
        let pro = { ...User }
        if (typeof pro.professional === 'object') {
            if (pro.professional) {
                pro.professional.services = e.target.value
            } else {
                pro.professional = {
                    services: e.target.value
                };
            }
        } else {
            pro['professional'] = {
                computerAccess: '',
                dateOfBirth: "",
                digitalMarketing: {},
                freelanceExperience: '',
                gender: '',
                internetAccess: '',
                languages: '',
                qualificationsAndCertificates: '',
                race: '',
                ratePerDay: '',
                ratePerHour: '',
                services: '',
                workingHours: ''
            }
            if (pro.professional) {
                pro.professional.services = e.target.value;
            } else {
                pro.professional = { services: e.target.value };
            }
        };
        setUser(pro)
    }
    function formatCash(number) {
        return new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(number);
    };
    function handleAccountTypeChange(e) {
        let user = { ...User }
        user.accountType = e.target.value;
        setUser(user)
    };
    function handlePaymentMethod(e) {
        let user = { ...User };
        user['paymentMethod'] = e.target.value;
        setUser(user);
    };
    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <>
                {(ViewProject) ?
                    <div style={{ width: '100%', height: '100%' }}>
                        <PreviewBrief project={SelectedProject} navigateMainToPage={(e, isUpdate) => backClicked(e, isUpdate)} professionals={Professionals} leads={Leads} />
                    </div>
                    :
                    <div className='ViewUser-Container'>
                        <div className='userDetailsSection'>

                            <div className='user-info-headerSection'>
                                <img src={BackIcon} onClick={handleNavigateToMainScreen} />
                                <p>{User.firstName || ''} {User.lastName || ''}</p>
                            </div>

                            <div className='user-info-bodySection'>

                                <div className='user-profile-CompDetails'>
                                    <div className='Profile-Picture'>
                                        <img src={UserIcon} style={{ width: '100%', height: '100%' }} />
                                    </div>
                                    <div className='user-oragnisationDetails'>
                                        {/* <p style={{ margin: '0px' }}>{User.companyName || ''}</p> */}
                                        <p >{User.email || ''}</p>
                                        <p style={{ margin: '0px' }}>{User.role ?? 'N/A'}</p>
                                    </div>
                                </div>

                                <div className='userEdit-AccountDetails'>
                                    <div className="tab-container">
                                        <div className="tabs">
                                            <div className={`tab ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => handleTabClick('profile')}>
                                                Profile
                                            </div>
                                            {/* <div className={`tab ${activeTab === 'bank-details' ? 'active' : ''}`} onClick={() => handleTabClick('bank-details')}>
                                                Finanial Details
                                            </div> */}
                                        </div>
                                        <div className={`underline ${activeTab}`}></div>
                                    </div>
                                    <img src={EditIcon} style={{ width: '5%', cursor: 'pointer' }} onClick={handleEditUser} />
                                </div>

                                {(IsEdit && activeTab === 'profile') ?
                                    <div className='user-credentials'>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Name & Surname' placeholder='Jerry Williams' value={FullName ?? ''} id='FullName' onChange={handleUserInfoChange} />
                                            <TextInput style={{ width: '47%' }} label='Email' placeholder='Email' value={User.email} id='Email' onChange={handleUserInfoChange} />
                                        </div>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Contact Number' placeholder='Contact Number' value={User.phone} id='Phone' onChange={handleUserInfoChange} />
                                            <TextInput style={{ width: '47%' }} label='Role' placeholder='Role' value={User.role} id='role' />
                                        </div>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Total Jobs' placeholder='19' value={User.briefs?.length + User.projects?.length} id='totaljobs' />
                                        </div>

                                        <div className='action-section'>
                                            <button className='btn-Cancel' onClick={cancelUpdateUser}>Cancel</button>
                                            <button className='btn-Save' onClick={updateUserClicked}>Save</button>
                                        </div>
                                    </div>
                                    : (IsEdit && activeTab == 'bank-details') ?
                                        <div className='user-credentials'>
                                            <div className='editname-Contact-Details'>
                                                <TextInputDropdown style={{ width: '47%' }} placeholder={'public'} label={'Account Type'} value={User.accountType} onChange={handleAccountTypeChange}>
                                                    {['public', 'personal']?.map((item, i) => {
                                                        return (
                                                            <MenuItem value={item}>{item}</MenuItem>
                                                        )
                                                    })}
                                                </TextInputDropdown>
                                                <TextInput style={{ width: '47%' }} label='Total Rands' placeholder='0,00' value={`ZAR ${
                                                    // formatCash(0)
                                                    ''
                                                    }`} id='TotalRands' />
                                            </div>
                                            <div className='editname-Contact-Details'>
                                                <TextInputDropdown style={{ width: '47%' }} placeholder={'EFT'} label={'Payment Method'} onChange={handlePaymentMethod} >
                                                    {['Voucher', 'EFT']?.map((item, i) => {
                                                        return (
                                                            null
                                                            // <MenuItem value={item}>{item}</MenuItem>
                                                        )
                                                    })}
                                                </TextInputDropdown>
                                                <TextInput style={{ width: '47%' }} label='VAT Number' placeholder='123456789' value={User.companyVatNumber} id='vatnumber' onChange={handleUserInfoChange} />
                                            </div>
                                            <div className='editname-Contact-Details'>
                                                <TextInput style={{ width: '47%' }} label='Company Registration' placeholder='w2eq324d5656f7' value={User.companyRegistrationNumber} id='compReg' onChange={handleUserInfoChange} />
                                                <TextInput style={{ width: '47%' }} label='Billing Address' placeholder='billing address' value={User.companyAddress} id='billing' onChange={handleUserInfoChange} />
                                            </div>
                                            <div className='action-section'>
                                                <button className='btn-Cancel' onClick={cancelUpdateUser}>Cancel</button>
                                                <button className='btn-Save' onClick={updateUserClicked}>Save</button>
                                            </div>
                                        </div>
                                        :
                                        (activeTab === 'profile') ?
                                            <div className='user-credentials'>

                                                <div className='name-contactsection'>
                                                    <div className='namesect'>
                                                        <p className='placeHolder'>Name & Surname</p>
                                                        <p className='value'>{User.firstName || ''} {' '}{User.lastName || ''}</p>
                                                    </div>
                                                    <div className='contactsect'>
                                                        <p className='placeHolder'>Email</p>
                                                        <p className='value'>{User.email || 'Not Assigned'}</p>
                                                    </div>
                                                </div>

                                                <div className='email-roleSection'>
                                                    <div className='emailsect'>
                                                        <p className='placeHolder'>Contact Number</p>
                                                        <p className='value'>{User.phone || 'Not Assigned'}</p>
                                                    </div>
                                                    <div className='rolesect' >
                                                        <p className='placeHolder'>Role</p>
                                                        <p className='value'>{User.role ?? "Not Assigned"}</p>
                                                    </div>
                                                </div>

                                                <div className='email-roleSection'>
                                                    <div className='emailsect'>
                                                        <p className='placeHolder'>Total Jobs</p>
                                                        <p className='value'>{User.briefs?.length + User.projects?.length}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            : (activeTab === 'bank-details') ?
                                                <div className='user-credentials'>
                                                    <div className='name-contactsection'>
                                                        <div className='namesect'>
                                                            <p className='placeHolder'>Account Type</p>
                                                            <p className='value'> {User.accountType ?? ''}</p>
                                                        </div>
                                                        <div className='contactsect'>
                                                            <p className='placeHolder'>Total Rands</p>
                                                            <p className='value'>{`ZAR ${formatCash(0)}`}</p>
                                                        </div>
                                                    </div>
                                                    <div className='email-roleSection'>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Payment Method</p>
                                                            <p className='value'></p>
                                                        </div>
                                                        <div className='rolesect'>
                                                            <p className='placeHolder'>VAT Number</p>
                                                            <p className='value'>{User.companyVatNumber || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                    <div className='email-roleSection'>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Company Registration</p>
                                                            <p className='value'>{User.companyRegistrationNumber || 'Not Assigned'}</p>
                                                        </div>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Billing Address</p>
                                                            <p className='value'>{User.companyAddress || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                null
                                }

                            </div>
                        </div>
                        <div className='user-project-section'>
                            <div className='project-header-container'>
                                <p >{TypeSelected}</p>
                                <div className='search-bar-section' style={{ width: '45%' }}>
                                    <img src={SearchIcon} alt='Search Icon' />
                                    <input style={{ color: '#6D4194' }} placeholder='Search' onChange={handleSearchChange} value={searchTerm}></input>
                                </div>
                            </div>

                            {/* JOB SECTION  */}
                            <div className='available-projects-container'>
                                {TypeSelected === 'Brief' ?
                                    Array.isArray(Briefs) && Briefs.length > 0 && Briefs.map((item, index) => {
                                        return (
                                            <div className='project-Card' key={index} onClick={() => getSelectedProject(item._id)}>
                                                <div className='briefHeaderSection'>
                                                    <p>{item.briefTitle}</p>
                                                </div>
                                                <div className='briefDetailssection'>
                                                    <div className='detailsSections'>
                                                        <div className='profileSection' style={{ width: '60%' }}>
                                                            <div className='profile'>
                                                                <img className='profilePicture' src={UserIcon} />
                                                            </div>
                                                            <div className='details'>
                                                                <p className='ValueplaceHolder'> {truncateString(`${item.client.firstName} ${item.client.lastName}`, 15)}</p>
                                                                <p className='textValue'> {item.client.accountType === 'personal' ? (item?.client?.email?.length > 15 ? String(`${item.client.firstName} ${item.client.lastName}`).substring(0, 13) + '...' : item?.client?.email) : (item?.client?.website?.length > 15 ? item.client.website.substring(0, 13) + '...' : item?.client?.website)}</p>
                                                            </div>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Start Date</p>
                                                            <p className='textValue'>{formatDate(item.projectStartDate) || ''}</p>
                                                        </div>
                                                    </div>
                                                    <div className='detailsSections'>
                                                        <div className='detailContainer' style={{ width: '60%' }}>
                                                            <p className='ValueplaceHolder'>Category of Service</p>
                                                            <p className='textValue'>{item?.serviceCategory ? item.serviceCategory : 'Not Assigned'}</p>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Fulfillment Lead</p>
                                                            <p className='textValue'>{item?.talentPartner ? `${item.talentPartner.firstName} ${item.talentPartner.lastName}` : ''}</p>
                                                        </div>
                                                    </div>
                                                    <div className='detailsSections'>
                                                        <div className='detailContainer' style={{ width: '60%' }}>
                                                            <p className='ValueplaceHolder'>Professionals</p>
                                                            <p className='textValue'>{item?.projectPlan && Array.isArray(item.projectPlan) && item.projectPlan.length > 0 && typeof item.projectPlan[0].professional === 'object' ? `${item.projectPlan[0].professional.firstName} ${item.projectPlan[0].professional.lastName}` : `Not Assigned`}</p>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Fulfillment Stage</p>
                                                            <p className='textValue'>{item.projectPlan[0].fulfillmentStage || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    :
                                    Array.isArray(Projects) && Projects.length > 0 && Projects.map((item, index) => {

                                        return (
                                            <div className='project-Card' key={index} onClick={() => getSelectedProject(item._id)}>
                                                <div className='briefHeaderSection'>
                                                    <p>{item.title || ''}</p>
                                                </div>
                                                <div className='briefDetailssection'>
                                                    <div className='detailsSections'>
                                                        <div className='profileSection' style={{ width: '60%' }}>
                                                            <div className='profile'>
                                                                <img className='profilePicture' src={UserIcon} />
                                                            </div>
                                                            <div className='details'>
                                                                <p className='ValueplaceHolder'> {truncateString(`${item.client.firstName} ${item.client.lastName}`, 15)}</p>
                                                                <p className='textValue'> {item.client.accountType === 'personal' ? (item?.client?.email?.length > 15 ? String(`${item.client.firstName} ${item.client.lastName}`).substring(0, 13) + '...' : item?.client?.email) : (item?.client?.website?.length > 15 ? item.client.website.substring(0, 13) + '...' : item?.client?.website)}</p>
                                                            </div>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Start Date</p>
                                                            <p className='textValue'>{item?.projectPlan?.projStartDate ? formatDate(new Date(item.projectPlan.projStartDate)) : 'No Date'}</p>
                                                        </div>
                                                    </div>
                                                    <div className='detailsSections'>
                                                        <div className='detailContainer' style={{ width: '60%' }}>
                                                            <p className='ValueplaceHolder'>Category of Service</p>
                                                            <p className='textValue'>{item?.serviceCategory ? item.serviceCategory : 'Not Assigned'}</p>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Fulfillment Lead</p>
                                                            <p className='textValue'>{item?.fulfillmentLead?.firstName || ''} {item?.fulfillmentLead?.lastName || ''}</p>
                                                        </div>
                                                    </div>
                                                    <div className='detailsSections'>
                                                        <div className='detailContainer' style={{ width: '60%' }}>
                                                            <p className='ValueplaceHolder'>Professionals</p>
                                                            <p className='textValue'>{User.firstName || ''} {User.lastName || ''}</p>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Fulfillment Stage</p>
                                                            <p className='textValue'>{item.projectPlan.fulfillmentStage || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className='viewBriefTypeSect' style={{ width: '93%' }}>
                                <div className={(TypeSelected === 'Brief' ? 'selectedType' : 'typeCard')} id='Brief' onClick={handleTabChange}>
                                    <p>Briefs</p>
                                </div>
                                <div style={{ marginLeft: '1.5%' }} className={(TypeSelected === 'Project' ? 'selectedType' : 'typeCard')} id='Project' onClick={handleTabChange}>
                                    <p>Projects</p>
                                </div>
                            </div>
                        </div>
                    </div >
                }
            </>
        )
    }

})

export default ViewClient;